module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/plans-and-payments-b40344c0f160600bd00082c71a694bc1.jpg";